import c0 from './accordion_component_controller';
import c1 from './alert_bar_controller';
import c2 from './audio_player_component_controller';
import c3 from './block/confirm_dialog_component_controller';
import c4 from './block/forms/color_picker_component_controller';
import c5 from './block/upload_status_widget_component_controller';
import c6 from './bridge/ready_controller';
import c7 from './button_component_controller';
import c8 from './drawer_controller';
import c9 from './dropdown_controller';
import c10 from './feature_callout_component_controller';
import c11 from './filters/date_range_component_controller';
import c12 from './forms/timestamp_component_controller';
import c13 from './media/audio_player_controller';
import c14 from './media/bridge/live_player_controller';
import c15 from './media/bridge/playback_controls_controller';
import c16 from './media/bridge/premiere_player_controller';
import c17 from './media/bridge/video_player_controller';
import c18 from './media/playback_controls_controller';
import c19 from './media/video_player_controller';
import c20 from './modal_component_controller';
import c21 from './offer_component_controller';
import c22 from './patreon_offer_component_controller';
import c23 from './price_component_controller';
import c24 from './qr_code_controller';
import c25 from './rolling_number_controller';
import c26 from './stats_component_controller';
import c27 from './targeting_component_controller';
import c28 from './tus_upload_component_controller';
import c29 from './typeahead_component_controller';
import c30 from './ui/table_component_controller';
import c31 from './ui/table_component_filter_controller';
export const definitions = [
	{identifier: 'accordion-component', controllerConstructor: c0},
	{identifier: 'alert-bar', controllerConstructor: c1},
	{identifier: 'audio-player-component', controllerConstructor: c2},
	{identifier: 'block--confirm-dialog-component', controllerConstructor: c3},
	{identifier: 'block--forms--color-picker-component', controllerConstructor: c4},
	{identifier: 'block--upload-status-widget-component', controllerConstructor: c5},
	{identifier: 'bridge--ready', controllerConstructor: c6},
	{identifier: 'button-component', controllerConstructor: c7},
	{identifier: 'drawer', controllerConstructor: c8},
	{identifier: 'dropdown', controllerConstructor: c9},
	{identifier: 'feature-callout-component', controllerConstructor: c10},
	{identifier: 'filters--date-range-component', controllerConstructor: c11},
	{identifier: 'forms--timestamp-component', controllerConstructor: c12},
	{identifier: 'media--audio-player', controllerConstructor: c13},
	{identifier: 'media--bridge--live-player', controllerConstructor: c14},
	{identifier: 'media--bridge--playback-controls', controllerConstructor: c15},
	{identifier: 'media--bridge--premiere-player', controllerConstructor: c16},
	{identifier: 'media--bridge--video-player', controllerConstructor: c17},
	{identifier: 'media--playback-controls', controllerConstructor: c18},
	{identifier: 'media--video-player', controllerConstructor: c19},
	{identifier: 'modal-component', controllerConstructor: c20},
	{identifier: 'offer-component', controllerConstructor: c21},
	{identifier: 'patreon-offer-component', controllerConstructor: c22},
	{identifier: 'price-component', controllerConstructor: c23},
	{identifier: 'qr-code', controllerConstructor: c24},
	{identifier: 'rolling-number', controllerConstructor: c25},
	{identifier: 'stats-component', controllerConstructor: c26},
	{identifier: 'targeting-component', controllerConstructor: c27},
	{identifier: 'tus-upload-component', controllerConstructor: c28},
	{identifier: 'typeahead-component', controllerConstructor: c29},
	{identifier: 'ui--table-component', controllerConstructor: c30},
	{identifier: 'ui--table-component-filter', controllerConstructor: c31},
];
